import React, { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import 'react-phone-input-2/lib/style.css';
import { useTranslation } from 'react-i18next';
import BasicForm from '../basicForm/basicForm';
import style from './reviewForm.module.scss';
import ButtonContainer from '../buttonContainer/buttonContainer';
import CheckBox from '../../Form/Preference/CheckBox/CheckBox';
import { useSelector } from 'react-redux';
import LoadingWithSpinner from '../../common/LoadingWithSpinner/LoadingWithSpinner';
import { CircularProgress } from '@mui/material';
import colors from '../../../scss/colors';

function ReviewForm(props) {
  const { nextHandle, cancel, data, back, navigate, step, totalStep, questionAvailable, jobTitle, setConsentChecked } =
    props;
  const { t } = useTranslation();
  const isJobBeingApplied = useSelector((state) => state.jobs?.pendingApplyV2);
  

  return (
    <BasicForm
      cancel={cancel}
      title={`${t('jobs.quickapply.userdetailheader')} ${jobTitle}`}
      progress="80"
      subtitle={t('jobs.quickapply.reviewform')}
      step={step}
      totalStep={totalStep}
    >
      <div className={style.reviewWrapper}>
        <div className={style.sectionWrapper}>
          <div className="row">
            <div className="col">
              <h4 className={style.header}>{t('jobs.quickapply.contactinfo')}</h4>
            </div>
            <div className="col text-right" style={{ textAlign: 'right' }}>
              <button className={style.editIcon} onClick={() => navigate('contact')}>
                <EditIcon />
              </button>
            </div>
          </div>
          <div className={style.detailWrapper}>
            <div className="row mb-3">
              <div className="col">
                <span className={style.key}>{t('jobs.quickapply.name')}</span>
                <span className={style.value}>{`${data?.firstName} ${data?.lastName}`}</span>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <span className={style.key}>{t('jobs.quickapply.email')}</span>
                <span className={style.value}>{data?.email}</span>
              </div>
              <div className="col">
                <span className={style.key}>{t('jobs.quickapply.phone')}</span>
                <span className={style.value}>{`${data?.PhoneCountryCode} ${data?.Phone}`}</span>
              </div>
            </div>
          </div>
        </div>

        <div className={style.sectionWrapper}>
          <div className="row">
            <div className="col">
              <h4 className={style.header}>{t('jobs.quickapply.yourattachment')}</h4>
            </div>
            <div className="col  text-right" style={{ textAlign: 'right' }}>
              <button className={style.editIcon} onClick={() => navigate('attachment')}>
                <EditIcon />
              </button>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col">
              <span className={style.key}>CV / Resume</span>
              <span className={style.value}>{data?.Cv?.name}</span>
            </div>
            {data?.CoverLetter && (<div className="col">
              <span className={style.key}>Cover Letter</span>
              <span className={style.value}>{data?.CoverLetter?.name}</span>
            </div>)}
          </div>
          <div className="row mb-3">
            {(data?.Document1 || data?.Document2 || data?.Document3) && (<div className="col">
              <span className={style.key}>Certificates or Supporting Documents</span>
              {data?.Document1 && <span className={style.value}>{data?.Document1?.name}</span>}
              {data?.Document2 && <span className={style.value}>{data?.Document2?.name}</span>}
              {data?.Document3 && <span className={style.value}>{data?.Document3?.name}</span>}
            </div>)}
          </div>
        </div>
        {!questionAvailable && (
          <div className={style.sectionWrapper}>
            <div className="row">
              <div className="col">
                <h4 className={style.header}>{t('jobs.quickapply.youranswers')}</h4>
              </div>
              <div className="col text-right" style={{ textAlign: 'right' }}>
                <button className={style.editIcon} onClick={() => navigate('answers')}>
                  <EditIcon />
                </button>
              </div>
            </div>
            {data?.Question1 ? (
              <div className="row mb-3">
                <div className="col">
                  <span className={style.key}>{data?.Question1}</span>
                  <span className={style.value}>{data?.Answer1 ? 'Yes' : 'No'}</span>
                </div>
              </div>
            ) : (
              <div />
            )}
            {data?.Question2 ? (
              <div className="row mb-3">
                <div className="col">
                  <span className={style.key}>{data?.Question2}</span>
                  <span className={style.value}>{data?.Answer2 ? 'Yes' : 'No'}</span>
                </div>
              </div>
            ) : (
              <div />
            )}
            {data?.Question3 ? (
              <div className="row mb-3">
                <div className="col">
                  <span className={style.key}>{data?.Question3}</span>
                  <span className={style.value}>{data?.Answer3 ? 'Yes' : 'No'}</span>
                </div>
              </div>
            ) : (
              <div />
            )}
          </div>
        )}
      </div>
      <div className={style.termsAndConditions}>
        <p>{t('jobs.quickapply.termsandconditionlabel1')}</p>
        <p className="mb-3">{t('jobs.quickapply.termsandconditionlabel2')}</p>
        <p className="mb-3">
          {t('jobs.quickapply.moreinfo')}
          <a href="https://www.airswift.com/terms-conditions" rel="noreferrer" target="_blank">
            <span>{t('jobs.quickapply.termsandconditions')}</span>
          </a>
          {t('jobs.quickapply.and')}
          <a href="https://www.airswift.com/privacy-cookie-policy/" rel="noreferrer" target="_blank">
            <span>{t('jobs.quickapply.privacypolicy')}</span>
          </a>
        </p>
      </div>
      <div className={style.consentText}>
        <CheckBox
          selected={data?.IsManageConcent}
          className={style.consentText}
          label={t('jobs.quickapply.consent')}
          onChange={(e) => setConsentChecked(e.target.checked)}
        />
      </div>
      <ButtonContainer
        actionCall={nextHandle}
        primaryText={t('common.general.back')}
        disabledPrimary={isJobBeingApplied}
        secondaryText={isJobBeingApplied ? <CircularProgress size="1rem" sx={{ color: colors.WHITE }} /> : t('common.general.apply')}
        back={back}
      />
    </BasicForm>
  );
}

export default ReviewForm;
